import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react'
import styles from './DatasetList.module.css'
import { message, Typography, Pagination, Select, Button } from 'antd'
import { useDispatch } from 'react-redux'
import { HTTP_URL } from '../../../../util/constants'
import Cookies from 'js-cookie'
import { getDatasetsListRequest } from './BotAndDatasetListApi'
import { clearAllCookies } from '../../../../util/handleObject'
import DatasetItem from './DatasetItem'
const { Text } = Typography
// export default function DatasetList(props) {
const DatasetList = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [datasetList, setDatasetList] = useState([])
  const [datasetNumber, setDatasetNumber] = useState(0)
  const [datasetCurrentPage, setDatasetCurrentPage] = useState(1)
  const [datasetPageSize, setDatasetPageSize] = useState(15)
  const [datasetStatus, setDatasetStatus] = useState('')

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getDatasetList(datasetStatus, '1', '15')
    return () => {}
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  useImperativeHandle(ref, () => ({
    getDatasetListFn() {
      getDatasetList(
        datasetStatus,
        String(datasetCurrentPage),
        String(datasetPageSize),
      )
    },
  }))
  function getDatasetList(status, offSet, limit) {
    getDatasetsListRequest(
      {
        space_id: Cookies.get('coze_space_id'),
        // name: agentName,
        name: '',
        format_type: status,
        page_num: offSet,
        page_size: limit, //这里接口有问题，page_size不起作用
      },
      (data) => {

        if (data.ret == 1) {
          let datasetList = data.data
          console.log(datasetList)
          let datasetList1 = datasetList.sort((a, b) => b.create_time - a.create_time)

          setDatasetList(datasetList1)
          setDatasetNumber(data.total)
        } else if (data.ret == 99) {
          messageApi.open({
            type: 'warning',
            // content: data.msg,
            content: data.msg,
          })
          setTimeout((e) => {
            sessionStorage.clear()
            clearAllCookies()
            window.location.reload()
          }, 1000)
        } else {
          message.warning(data.msg)
        }
      },
    )
  }

  const onShowSizeChange = (current, pageSize) => {
    setDatasetCurrentPage(current)
    setDatasetPageSize(pageSize)
    getDatasetList(datasetStatus, String(current), String(pageSize))
  }
  const pageChange = (current, pageSize) => {
    setDatasetCurrentPage(current)
    setDatasetPageSize(pageSize)
    getDatasetList(datasetStatus, String(current), String(pageSize))
  }

  const clickDatasetItem = (item) => {
    window.open(
      HTTP_URL +
        `gongju/preview/index.html?datasetId=${item.dataset_id}&icon=${btoa(item.icon_url)}&title=${item.dataset_name}&userToken=${Cookies.get('userToken')}`,
    )
  }
  return (
    <div className={styles.background} style={{ paddingDatasettom: 30 }}>
      <div className={styles.topBox}>
        <div style={{ width: 160 }}>
          <span>类型</span>
          <Select
            style={{ marginLeft: 30, width: 88,backgroundColor:'white' }}
            onChange={(value) => {
              setDatasetStatus(value)
              getDatasetList(
                value,
                String(datasetCurrentPage),
                String(datasetPageSize),
              )
            }}
            value={datasetStatus}
            options={[
              {
                value: '',
                label: '全部',
              },
              {
                value: '0',
                label: '文本',
              },
              {
                value: '2',
                label: '照片',
              },
            ]}
          />
        </div>
        <Button
          color="primary"
          variant="outlined"
          style={{ marginLeft: 30 ,marginRight: 34,backgroundColor:'white' }}
          onClick={props.backMethod}
        >
          返回上一页面
        </Button>
      </div>
      <div className={styles.datasetListBox}>
        <div className={styles.tableTitleBox}>
          <span style={{width: "35%"}} className={styles.datasetTitle}>文件名</span>
          <span style={{width: "10%"}} className={styles.datasetTitle1}>类型</span>
          <span style={{width: "45%"}} className={styles.datasetTitle}>描述</span>
          <span style={{width: "10%"}} className={styles.datasetTitle1}>操作</span>
        </div>
        {datasetList.map((item, index) => (
          <DatasetItem
            key={index}
            info={item}
            index={index}
            clickDatasetItem={clickDatasetItem}
            getDatasetList={() =>
              getDatasetList(
                datasetStatus,
                String(datasetCurrentPage),
                String(datasetPageSize),
              )
            }
            editMethod={props.editMethod}
          />
        ))}
      </div>
      <Pagination
        align="end"
        defaultCurrent={datasetCurrentPage}
        total={datasetNumber}
        pageSize={datasetPageSize}
        pageSizeOptions={[15, 20, 25, 30, 35, 40]}
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        onChange={pageChange}
        style={{ marginRight: 64 }}
      />
    </div>
  )
})
export default DatasetList
